require('./home-index.css');

document.addEventListener("DOMContentLoaded", () => {
    const form = document.querySelector("#registerUser");

    // 🛡️ Validates CAPTCHA consents, shows/hides warnings, blocks form if needed
    const validateCaptchaConsent = () => {
        const manager = window.klaro?.getManager?.();
        if (!manager) return false;

        const consent = {
            friendlycaptcha: manager.getConsent('Friendly Captcha'),
            hcaptcha: manager.getConsent('hcaptcha'),
            recaptcha: manager.getConsent('recaptcha')
        };

        let isValid = true;

        const toggleWarning = (enabled, allowed, id) => {
            const el = document.getElementById(id);
            if (enabled && !allowed) {
                el?.classList.remove('d-none');
                isValid = false;
            } else {
                el?.classList.add('d-none');
            }
        };

        toggleWarning(window.APP_CONFIG.friendlyCaptchaEnabled, consent.friendlycaptcha, 'fc-warning');
        toggleWarning(window.APP_CONFIG.hCaptchaEnabled, consent.hcaptcha, 'hcaptcha-warning');
        toggleWarning(window.APP_CONFIG.reCaptchaEnabled, consent.recaptcha, 'recaptcha-warning');

        return isValid;
    };

    // 🧪 Watch Klaro consent changes
    const manager = window.klaro?.getManager?.();
    if (manager) {
        manager.watch({
            update(obj, name, data) {
                if (name === 'consents') {
                    validateCaptchaConsent();
                }
            }
        });
    }

    // ✅ JustValidate setup
    if (form) {
        const validator = new JustValidate(form, {
            errorFieldCssClass: "is-invalid",
            successFieldCssClass: "is-valid",
            errorLabelCssClass: "invalid-feedback",
        });

        validator
            .addField("#registerUsername", [
                { rule: "required", errorMessage: "Bitte gib einen Benutzernamen ein." },
                { rule: "minLength", value: 2, errorMessage: "Dein Benutzername muss aus mindestens zwei Zeichen bestehen." },
                { rule: "maxLength", value: 60, errorMessage: "Der Benutzername darf maximal 60 Zeichen lang sein." },
                { validator: value => !value.includes('/'), errorMessage: "Der Benutzername darf das Zeichen / nicht enthalten." }
            ])
            .addField("#email1", [
                { rule: "required", errorMessage: "Bitte gib eine E-Mail Adresse ein." },
                { rule: "email", errorMessage: "Bitte gib eine gültige E-Mail Adresse ein." },
                { rule: "maxLength", value: 100, errorMessage: "Die E-Mail Adresse darf maximal 100 Zeichen lang sein." }
            ])
            .addField("#email2", [
                { rule: "required", errorMessage: "Bitte bestätige deine E-Mail Adresse." },
                { 
                    validator: (value, fields) => value === fields["#email1"].elem.value, 
                    errorMessage: "Die E-Mail Adressen stimmen nicht überein."
                }
            ])
            .addField("#password1", [
                { rule: "required", errorMessage: "Bitte gib ein Passwort ein." },
                { 
                    validator: (value) => window.customValidations.password2(value), 
                    errorMessage: "Das Passwort muss 8-20 Zeichen lang sein und mindestens eine Zahl, ein Sonderzeichen, einen Groß- und Kleinbuchstaben enthalten." 
                },
                { rule: "maxLength", value: 20, errorMessage: "Das Passwort darf maximal 20 Zeichen lang sein." },
                { rule: "minLength", value: 8, errorMessage: "Das Passwort muss mindestens 8 Zeichen lang sein." },
            ])
            .addField("#password2", [
                { rule: "required", errorMessage: "Bitte bestätige dein Passwort." },
                { 
                    validator: (value, fields) => value === fields["#password1"].elem.value, 
                    errorMessage: "Die Passwörter stimmen nicht überein."
                }
            ])
            .onSuccess(() => {  
                if (validateCaptchaConsent()) {
                    form.submit();  
                } else {
                    console.warn("⛔ CAPTCHA consent not given. Form submission blocked.");
                }
            });
    }

    // ⏳ Run initial check shortly after Klaro loads
    setTimeout(() => {
        validateCaptchaConsent();
    }, 200);

    // 💬 Klaro dialog triggers
    document.querySelectorAll('.open-klaro').forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            window.klaro?.show();
        });
    });

    document.getElementById('test-klaro-click')?.addEventListener('click', () => {
        console.log("Test button clicked");
        window.klaro?.show();
    });
});